<template>
  <div class="field mb-5">
    <label class="label">{{ label }}</label>
    <span>{{ description }}</span>
    <div class="control mt-2">
      <input
        class="input"
        :type="type"
        :min="min"
        v-model="inputValue"
        @input="handleInput"
        :placeholder="placeholder"
      />
    </div>
    <p v-if="errorMessage" class="help is-danger">{{ errorMessage }}</p>
    <p v-if="isSaving" class="help is-info">Saving...</p>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useDebounce } from '@/composables/useDebounce';
import { useSettings } from '@/lib/settings';

export default {
  props: {
    label: String,
    description: String,
    type: {
      type: String,
      default: 'text'
    },
    min: Number,
    placeholder: String,
    validator: Function,
    settingKey: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { debounce } = useDebounce();
    const { getSetting, setSetting } = useSettings();
    const inputValue = ref(null);
    const errorMessage = ref(null);
    const isSaving = ref(false);

    onMounted(() => {
      inputValue.value = getSetting(props.settingKey);
    });

    const handleInput = debounce('input', async () => {
      const value = props.type === 'number' ? Number(inputValue.value) : inputValue.value;
      errorMessage.value = props.validator ? props.validator(value) : null;
      if (!errorMessage.value) {
        isSaving.value = true;
        await setSetting(props.settingKey, value);
        isSaving.value = false;
      }
    });

    return {
      inputValue,
      errorMessage,
      isSaving,
      handleInput
    };
  }
}
</script>